<template>
  <main>
    <v-toolbar flat color="white" class="mb-4">
      <v-toolbar-title>{{ $t("route.tags") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-btn @click="$refs.table_ref.toggleDialog()" color="primary">
        {{ $t("button.create") }}
      </v-btn>
    </v-toolbar>
    <wrapping-table
      @on_dialog_close="onDialogClose"
      pathName="tags"
      :headersName="headers"
      ref="table_ref"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">{{ item.name }}</td>
        <td class="toggle-adjust">
          <toggle-service
            :is-edit="true"
            model-name="tags"
            :model-id="item.id"
            field="visible"
            v-model="item.visible"
            :validate="true"
          />
        </td>
        <td class="text-sm-center">
          <v-icon
            :title="$t('icon.edit')"
            small
            @click="handleEdit(item, index)"
            >mdi-pencil</v-icon
          >
          <v-icon
            :title="$t('icon.delete')"
            small
            @click="handleDelete(item, index)"
            >mdi-delete</v-icon
          >
        </td>
      </template>
      <!-- dialog -->
      <template #wrraping_dialog>
        <v-card-title class="dialog-header ">{{ formTitle }}</v-card-title>
        <v-card-text>
          <v-form @submit.prevent="handleSubmit">
            <form-wrapper :validator="$v.form">
              <v-container>
                <v-row>
                  <v-col cols="12" v-if="isEdit">
                    <locale-select @change="onLocaleChange" />
                  </v-col>
                  <v-row>
                    <transition name="fadeIn" mode="out-in">
                      <v-col :cols="tagNotEmpty && !isEdit ? 11 : 12">
                        <form-group name="name">
                          <template slot-scope="{ attrs, listeners }">
                            <v-text-field
                              :loading="loading"
                              v-bind="attrs"
                              v-on="listeners"
                              v-model="form.name"
                              outlined
                            ></v-text-field>
                          </template>
                        </form-group>
                      </v-col>
                    </transition>

                    <v-col v-if="tagNotEmpty && !isEdit" cols="1" class="mt-3">
                      <v-btn @click="addTag" icon :title="$t('button.add_tag')">
                        <v-icon large>mdi-plus-box</v-icon>
                      </v-btn>
                    </v-col>

                    <transition-group name="fadeIn" mode="out-in">
                      <ul v-if="serverErrors" key="1">
                        <li
                          class="error-message"
                          v-for="(errorKey, index) in errorsKeys"
                          :key="index"
                        >
                          {{ getTagError(errorKey, serverErrors[errorKey]) }}
                        </li>
                      </ul>
                      <v-col
                        key="2"
                        class="m-0 p-0"
                        cols="12"
                        v-if="tags.length > 0"
                      >
                        <v-chip
                          class="mx-2"
                          @click:close="deleteTag(index)"
                          v-for="(tag, index) in tags"
                          :key="index"
                          pill
                          close
                        >
                          {{ tag }}
                        </v-chip>
                      </v-col>
                    </transition-group>
                  </v-row>
                  <v-col cols="12">
                    <v-btn
                      class="primary"
                      type="submit"
                      :disabled="validateTags"
                      block
                      >{{ $t("button.submit") }}</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </form-wrapper>
          </v-form>
        </v-card-text>
      </template>
      <!-- dialog -->
    </wrapping-table>
  </main>
</template>
<script>
import { minLength, maxLength } from "vuelidate/lib/validators";

import { ShowData, UpdateData } from "@/helpers/apiMethods";
import cookie from "js-cookie";
export default {
  name: "Tags",
  data() {
    return {
      isEdit: false,
      loading: false,
      locale: this.locale,
      form: { name: "" },
      tags: [],
      headers: ["name", "visible", "actions"],
      tagItem: {},
      tagIndex: ""
    };
  },
  methods: {
    getTagError(tagKey, errorValue) {
      const index = Number(tagKey.match(/\d+/g)[0]);
      const error = errorValue[0];
      return error.replace(`tags.${index}`, this.tags[index]);
    },
    handleSubmit() {
      this.loading = true;
      if (!this.isEdit) {
        // in case create
        const formData = new FormData();
        this.tags.forEach((tag) => {
          formData.append("tags[]", tag);
        });
        this.$refs.table_ref.handleOnCreate("tags", formData).finally(() => {
          this.loading = false;
        });
      } else {
        // in case update
        UpdateData({
          reqName: "tags",
          data: { name: this.form.name, locale: this.locale, _method: "put" },
          id: this.tagItem.id
        })
          .then((res) => {
            const { tag } = res.data;
            this.$refs.table_ref.handleUpdateItems(tag, this.tagIndex);
            this.$refs.table_ref.toggleDialog();
          })
          .finally(() => (this.loading = false));
      }
    },
    resetData() {
      this.form.name = "";
      this.$v.form.$reset();
    },
    deleteTag(index) {
      this.$delete(this.tags, index);
      if (this.serverErrors) {
        this.$store.dispatch("ClearServerErrors");
      }
    },
    addTag() {
      if (this.tags.includes(this.form.name)) {
        return;
      }
      this.tags.push(this.form.name);
      this.resetData();
    },
    onDialogClose() {
      this.resetData();
      this.isEdit = false;
      this.locale = cookie.get("language");
      this.tags = [];
    },
    handleDelete({ id }, index) {
      this.$refs.table_ref.handleDelete(id, index);
    },
    handleEdit(item, index) {
      this.isEdit = true;
      this.tagItem = item;
      this.tagIndex = index;
      this.$refs.table_ref.toggleDialog();
      this.handleShow();
    },
    handleShow(locale = this.locale) {
      ShowData({ reqName: "tags", id: this.tagItem.id, locale }).then((res) => {
        const { tag } = res.data;
        this.form.name = tag.name;
      });
    },
    onLocaleChange(locale) {
      this.locale = locale;
      this.handleShow(locale);
    }
  },
  computed: {
    formTitle() {
      if (!this.isEdit) {
        return this.$t("heading.create");
      } else {
        return this.$t("heading.edit");
      }
    },
    validateTags() {
      if (!this.isEdit) {
        if (
          this.tags.length === 0 ||
          this.$v.form.$invalid ||
          this.form.name !== ""
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        if (this.$v.form.$invalid) {
          return true;
        } else {
          return false;
        }
      }
    },
    tagNotEmpty() {
      if (this.form.name !== "") {
        return true;
      } else {
        return false;
      }
    },
    serverErrors() {
      return this.$store.getters.serverErrors;
    },
    errorsKeys() {
      return Object.keys(this.serverErrors);
    }
  },
  validations: {
    form: {
      name: {
        minLength: minLength(2),
        maxLength: maxLength(20)
      }
    }
  }
};
</script>

<style>
.error-message {
  color: red;
  font-weight: bold;
}
</style>
